import { render, staticRenderFns } from "./PatientAllergiesV1.vue?vue&type=template&id=3f78084e&"
import script from "./PatientAllergiesV1.vue?vue&type=script&lang=js&"
export * from "./PatientAllergiesV1.vue?vue&type=script&lang=js&"
import style0 from "./PatientAllergiesV1.vue?vue&type=style&index=0&id=3f78084e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Kiosk.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports